import { renderButtonField } from '../renderers/ButtonField';
import { renderComputedField } from '../renderers/ComputedField';
import { renderInputField } from '../renderers/InputField';
import { renderNumberInput } from '../renderers/NumberInputField';
import { renderPortDestinations } from '../renderers/PortDestinationsField';
import { renderPortsEditor } from '../renderers/PortsEditorField';
import { renderSelectBox } from '../renderers/SelectBoxField';
import { renderTextInput } from '../renderers/TextInputField';
import { renderDestinationField } from './DestinationField';
import { renderTimeInput } from './TimeInputField';

export function createFieldRenderer(field, path, inspectorInstance) {
  const cellId = field.cellId;
  const cell = inspectorInstance.graph.getCell(cellId);
  if (!cell) {
    inspectorInstance.closeInspector();
    return;
  }

  switch (field?.type) {
    case 'text':
      return renderTextInput(field, cell, inspectorInstance.theme);
    case 'number':
      return renderNumberInput(field, cell, inspectorInstance.theme);
    case 'select-box':
      return renderSelectBox(field, cell, inspectorInstance.theme, inspectorInstance.modules);
    case 'computed':
      return renderComputedField(field, cell, inspectorInstance.theme);
    case 'input':
      return renderInputField(field, cell, inspectorInstance.theme);
    case 'button':
      return renderButtonField(field, inspectorInstance.theme, cell, inspectorInstance.graph);
    case 'ports-editor':
      return renderPortsEditor(
        field,
        cell,
        inspectorInstance.theme,
        inspectorInstance.graph,
        inspectorInstance.paper,
        inspectorInstance.inspector
      );
    case 'port-destinations':
      return renderPortDestinations(
        field,
        cell,
        inspectorInstance.graph,
        inspectorInstance.updatePorts.bind(inspectorInstance),
        inspectorInstance.updatePortLinks.bind(inspectorInstance)
      );
    case 'time':
      return renderTimeInput(field, cell, inspectorInstance.theme);
    case 'destinationField':
      return renderDestinationField(
        field,
        cell,
        inspectorInstance.graph,
        inspectorInstance.paper,
        inspectorInstance.inspector
      );
    default:
      return undefined;
  }
}
